import { useContext } from 'react';
import APIErrorContext from '../contexts/apiError.context';

export default function useAPIError() {
  return useContext(APIErrorContext);
}
